import { render, staticRenderFns } from "./contact-birthdate-picker.vue?vue&type=template&id=cdeaaa0c&scoped=true&"
import script from "./contact-birthdate-picker.ts?vue&type=script&lang=ts&"
export * from "./contact-birthdate-picker.ts?vue&type=script&lang=ts&"
import style0 from "./contact-birthdate-picker.scss?vue&type=style&index=0&id=cdeaaa0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdeaaa0c",
  null
  
)

export default component.exports